import { render, staticRenderFns } from "./inits.vue?vue&type=template&id=664c397e&scoped=true"
import script from "./inits.vue?vue&type=script&lang=js"
export * from "./inits.vue?vue&type=script&lang=js"
import style0 from "./inits.vue?vue&type=style&index=0&id=664c397e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664c397e",
  null
  
)

export default component.exports